
import React, { useEffect } from 'react';
import "../Assets/styles/Services.css"
import ServiceBanShape from "../Assets/Resources/service-ban-shape.png"
import Serviceoneimg from "../Assets/Resources/service-one-1.png"
import RightArrow from "../Assets/Resources/service-right-arrow.svg"
import KeyBenefitsImg from "../Assets/Resources/adobe-benefits-img.png"
import KeyBenefitsImg2 from "../Assets/Resources/adobe-benefits-img-2.png"
import KeyBenefitsImg3 from "../Assets/Resources/adobe-benefits-img-3.png"
import KeyBenefitsImg4 from "../Assets/Resources/adobe-benefits-img-4.png"
import KeyBenefitsImg5 from "../Assets/Resources/adobe-benefits-img-5.png"
import AiDataImage from "../Assets/Resources/ai-data-img.png"
import Logo from "../Assets/Resources/banner-logo.svg";
import Slider from "react-slick";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitType from 'split-type'
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceStar from "../Assets/Resources/service-star.svg"
import AllPageLoader from '../Components/AllPageLoader';

const CloudandDevOps = () => {


    const serSettings = {
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200, // For screens smaller than 1200px
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992, // For screens smaller than 992px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768, // For screens smaller than 768px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576, // For screens smaller than 576px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };




    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);



    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);







    return (
        <>
            <AllPageLoader />
            <section className='service-hero-section'>
                <div className="container-fluid common-btn">
                    <div className="row">
                        <div className="banner-content">
                            <h1 className='ban-title-animation'>Prophecy <br />Technologies</h1>
                            <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="500">Optimize, Automate, Elevate: Cloud & DevOps Excellence!</h6>
                            <p data-aos="fade-down" data-aos-duration="2000" data-aos-delay="700">Optimize, automate, and elevate your infrastructure with Prophecy Technologie’s Cloud
                                & DevOps solutions. We streamline your workflows, reduce deployment time, and
                                maximize system reliability for seamless scalability</p>
                            <a href="/contact">
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Talk with Our Experts</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="service-hero-shape">
                    <img src={ServiceBanShape} alt="" />
                </div>
            </section>


            <section className='service-section-one  sec-padding smarteerTomorrow service-sec'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="content large-title">
                                <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">Benefits DevOps Brings to Your</h6>
                                <h1 className='mini-title-animation'>Deployment <br />Process</h1>
                                <p className='para-animation'>DevOps streamline your deployment process by fostering seamless collaboration
                                    between development and operations teams, reducing silos and improving
                                    communication. This unified approach enables faster releases, minimizing downtime
                                    and ensuring that new features or updates reach users swiftly. By automating repetitive
                                    tasks, DevOps also enhances consistency and reduces errors, resulting in more reliable
                                    deployments.</p>
                                <p className='para-animation'>With DevOps, you gain the flexibility to scale and adapt to changing project needs
                                    without compromising quality or speed. Continuous integration and continuous delivery
                                    (CI/CD) practices allow for frequent testing and adjustments, ensuring high-quality code
                                    with minimal risks. Prophecy Technologies’ DevOps solutions empower your team to
                                    deploy confidently and efficiently, driving a smoother, more resilient deployment
                                    process.
                                </p>
                                <a href="/contact" className='common-btn service-large-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Get Started With Us Now!</button>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-left" data-aos-duration="2000" data-aos-delay="300">
                                <img src={AiDataImage} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">How Does Cloud Automation</h6>
                                    <h1 className='mini-title-animation'>Reduce <br />Operational <br />Costs?</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>Cloud automation from Prophecy Technologies reduces operational costs by
                            streamlining resource management, improving efficiency, and minimizing manual
                            workloads.
                        </p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Efficient Resource Allocation</h6>
                                                <p>Cloud automation optimizes resource usage, automatically adjusting resources based
                                                    on demand to prevent overprovisioning and unnecessary spending.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. Reduced Manual Intervention</h6>
                                                <p>By automating repetitive tasks, cloud automation decreases the need for manual
                                                    oversight, lowering labour costs and freeing up your team for high-impact projects.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Scalability on Demand
                                                </h6>
                                                <p>With automated scaling, you can add or reduce resources instantly, adjusting to
                                                    demand without incurring the high costs of fixed infrastructure.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Improved Energy Efficiency</h6>
                                                <p>Automation optimizes workloads and server usage, reducing energy consumption and
                                                    lowering costs associated with data center power and cooling.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Streamlined Disaster Recovery</h6>
                                                <p>Automated backups and failover processes reduce the resources needed for disaster
                                                    recovery, making it more cost-effective to protect data and maintain uptime</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>6. Enhanced Security Management</h6>
                                                <p>Automated security updates and compliance checks reduce the need for manual
                                                    monitoring, decreasing potential risks and the costs of security breaches.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>7. Simplified Software Management
                                                </h6>
                                                <p>Automation streamlines software updates, patching, and deployments, reducing the
                                                    operational costs associated with maintenance and support</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>8. Decreased Downtime Costs</h6>
                                                <p>Automated monitoring and quick issue resolution reduce downtime, minimizing the
                                                    revenue losses and productivity disruptions of manual recovery.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                                <p className='para-animation'>Prophecy Technologies’ cloud automation solutions drive cost savings by enhancing
                                    efficiency, scalability, and security across your cloud infrastructure.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">Steps Needed to</h6>
                                <h1 className='mini-title-animation'> Build Your <br />DevOps Pipeline</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>Building an effective DevOps pipeline with Prophecy Technologies involves a series of
                        steps designed to streamline and automate your software development lifecycle.

                    </p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Define Goals and Requirements</h6>
                                            <p>Identify project goals and technical requirements to ensure your pipeline aligns with
                                                business objectives and meets development needs</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Set Up Version Control</h6>
                                            <p>Establish a robust version control system to manage code changes, enhance
                                                collaboration, and maintain a central code repository.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Implement Continuous Integration (CI)
                                            </h6>
                                            <p>Configure CI to automatically integrate code changes and run initial tests, reducing
                                                errors and maintaining code stability</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Automate Testing Processes</h6>
                                            <p>Set up automated testing to validate code quality at each stage, catching bugs early and
                                                ensuring consistent performance.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Configure Monitoring and Logging</h6>
                                            <p>Implement monitoring tools to track application performance, ensuring you can quickly
                                                detect and resolve issues post-deployment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>6. Establish Security Measures</h6>
                                            <p>Integrate automated security checks into the pipeline to detect vulnerabilities early and
                                                ensure compliance with security standards.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                            <p className='para-animation'>Prophecy Technologies supports you in building a DevOps pipeline that accelerates
                                delivery, enhances quality, and fosters continuous improvement.</p>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Take the First Step with Prophecy Now!</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="300">Cloud & DevOps in Action:</h6>
                                    <h1 className='mini-title-animation'>Tools for <br />Seamless <br />Deployment</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg3} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>Prophecy Technologies leverages powerful cloud and DevOps tools to create seamless,
                            efficient deployment pipelines that enhance agility and reliability
                        </p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Azure: Robust Infrastructure for All Environments</h6>
                                                <p>Azure provides a scalable, cloud-based platform that supports continuous integration
                                                    and deployment, enabling faster, more reliable releases across development stages.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. AWS: Flexible and Reliable DevOps Solutions</h6>
                                                <p>AWS offers a suite of DevOps tools, from CodePipeline to CloudFormation, helping
                                                    automate the deployment process and ensuring consistency across complex
                                                    applications.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Google Cloud: AI-Powered Automation and Monitoring</h6>
                                                <p>With its advanced AI and monitoring tools, Google Cloud enables automated
                                                    deployments, error detection, and real-time insights that keep your pipeline running
                                                    smoothly</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Containerization with Docke</h6>
                                                <p>Docker streamlines app deployment by packaging applications into containers, making
                                                    them portable across different environments and reducing setup times.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Automated Testing with Selenium
                                                </h6>
                                                <p>Selenium integrates seamlessly into the DevOps pipeline, automating browser testing
                                                    and ensuring application quality across different environments.</p>
                                            </div>
                                        </div>
                                    </div>

                                </Slider>
                                <p className='para-animation'>Prophecy Technologies brings together the best of Azure, AWS, and Google Cloud with
                                    DevOps tools for a streamlined, resilient deployment process.</p>
                                <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Contact Us To Get Started
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="300">How Do We Help Your Team</h6>
                                <h1 className='mini-title-animation'>Adopt Cloud <br />& DevOps Best <br />Practices?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>Prophecy Technologies helps your team adopt cloud and DevOps best practices,
                        enhancing efficiency, agility, and reliability across your deployment processes.</p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Comprehensive Needs Assessment</h6>
                                            <p>We begin by assessing your team’s specific requirements and current workflows,
                                                ensuring our approach aligns with your unique goals and challenges.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Hands-On Implementation Support
                                            </h6>
                                            <p>We offer hands-on guidance during implementation, assisting with tool integration,
                                                configuration, and workflow optimization for a smooth transition.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Establishing CI/CD Pipelines</h6>
                                            <p>Prophecy sets up continuous integration and continuous delivery (CI/CD) pipelines,
                                                enabling faster, error-free releases and improving code reliability</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Automation of Key Processes
                                            </h6>
                                            <p>Our team automates repetitive tasks within your deployment pipeline, saving time,
                                                reducing errors, and allowing your team to focus on innovation.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Ongoing Monitoring and Analytics</h6>
                                            <p>We implement monitoring and analytics tools that provide real-time insights,
                                                empowering your team to maintain performance and quickly resolve issues.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>6. Security Best Practices Integration</h6>
                                            <p>Prophecy ensures security best practices are integrated into your DevOps workflows,
                                                helping your team protect against vulnerabilities and maintain compliance.</p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                            <p className='para-animation'>With Prophecy Technologies, your team gains the expertise, tools, and support needed
                                to adopt cloud and DevOps best practices confidently and successfully.
                            </p>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Schedule a Free Consultation With Us!</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>




            <section className='cta-section common-btn sec-padding service-page-cta'>
                <div className="container">
                    <div className="row">
                        <div className="sec-title">
                            <div className="large-title">
                                <h1 className='mini-title-animation'>Discover Cloud & <br />DevOps Innovations </h1>
                            </div>
                            <p data-aos="fade-up" data-aos-duration="2000">Unlock new possibilities in efficiency and agility with our Cloud & DevOps
                                innovations. From streamlined deployments to optimized workflows, we’re here
                                to elevate your business infrastructure. Connect with us today to transform your
                                cloud journey!</p>
                            <a href="/contact" className='common-btn '>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Connect Now
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default CloudandDevOps